// 越南
export default {
    login: {
        t01: 'Ngôn ngữ',
        t02: 'Netflix',
        t03: 'Vui lòng nhập tên người dùng',
        t04: 'Vui lòng nhập mật khẩu',
        t05: 'Đăng nhập',
        t06: 'Đăng ký',
        t07: 'Vui lòng nhập số điện thoại',
        t08: 'Xác nhận mật khẩu',
        t09: 'Vui lòng nhập mã mời',
        t10: 'Tạo tài khoản',
        t11: 'Vui lòng xác nhận mật khẩu',
        t13: 'Tình yêu dành cho điện ảnh có thể giúp bạn tích lũy được khối tài sản dồi dào một cách vô tình.',
        t14: 'Đăng nhập thành công',
        t15: 'Mật khẩu không khớp',
        t16: 'Đăng ký thành công',
        t17: 'Lỗi mạng',
        t18: 'Yêu cầu timeout, vui lòng kiểm tra kết nối internet của bạn'
    },
    cover_info: {
        t01: 'Bắt đầu kiếm tiền',
        t02: 'Nạp tiền',
        t03: 'Rút tiền',
        t04: 'Chứng chỉ'
    },
    cont: {
        t01: 'Chọn Ngôn Ngữ',
        t02: 'Tất cả',
        t03: 'Đang chờ',
        t04: 'Hoàn thành',
        t05: 'Đóng băng',
        t06: 'Số Dư Của Tôi',
        t07: 'Chưa hoàn thành',
        t08: 'Tổng đơn hàng',
        t09: 'Hoa hồng',
        t10: 'Thu nhập',
        t11: 'Số lượng đơn hàng',
        t12: 'Số dư khả dụng',
        t13: 'Bắt đầu đặt hàng',
        t14: 'Tiền trong tài khoản',
        t15: 'Gửi đơn hàng',
        t16: 'Gửi tất cả các đơn hàng',
        t17: 'Thời gian đặt hàng',
        t18: 'Mã số đơn hàng',
        t19: 'Tổng giá trị đơn hàng',
        t21: 'Tác phẩm',
        t22: 'Diễn viên',
        t23: 'Bình luận về tác phẩm',
        t24: 'Hủy bỏ',
        t25: 'Chọn đánh giá',
        t26: 'Gửi đơn hàng hoàn tất',
        t27: 'Đã đặt hàng',
        t28: 'Đặt hàng thành công',
        t29: 'Đặt hàng không thành công, Vui lòng thử lại!'
    }
    ,
    user: {
        t1: 'Mã quảng cáo',
        t2: 'Số dư của tôi',
        t3: 'Số dư khả dụng',
        t4: 'Thu nhập tổng',
        t5: 'Rút tiền',
        t6: 'Lịch sử nạp tiền',
        t7: 'Lịch sử rút tiền',
        t8: 'Chi tiết tài khoản',
        t9: 'Tin nhắn',
        t10: 'Kết nối thẻ ngân hàng',
        t11: 'Đổi mật khẩu',
        t12: 'Sửa mật khẩu rút tiền',
        t13: 'Mời bạn bè',
        t14: 'Chọn ngôn ngữ',
        t15: 'Thoát ra',
        t16: 'Rút tiền',
        t17: 'Tiền có thể rút',
        t18: 'Tên chủ tài khoản',
        t19: 'Số điện thoại di động',
        t20: 'Số tiền rút',
        t21: 'Rút tiền',
        t22: 'Vui lòng nhập số tiền rút',
        t23: 'Vui lòng nhập mật khẩu ví',
        t24: 'Tổng nạp tiền',
        t25: 'Thông báo hệ thống',
        t26: 'Thông tin thẻ ngân hàng của bạn',
        t27: 'Danh sách ngân hàng',
        t28: 'Tên ngân hàng',
        t29: 'Họ',
        t30: 'Số thẻ ngân hàng',
        t31: 'Số điện thoại liên lạc',
        t32: 'Đồng ý sửa đổi',
        t33: 'Vui lòng nhập đúng số tài khoản và số IFSC của thẻ ngân hàng đã liên kết, cũng như điền đầy đủ họ và số điện thoại di động thực tế, nếu không, tiền gửi sẽ không thể đến.',
        t34: 'Mật khẩu cũ',
        t35: 'Mật khẩu mới',
        t36: 'Xác nhận mật khẩu',
        t37: 'Tiếp theo',
        t38: 'Vui lòng nhớ mật khẩu, nếu quên mật khẩu, vui lòng liên hệ với bộ phận chăm sóc khách hàng.',
        t39: 'Sao chép liên kết mời bạn',
        t40: 'Mời bạn bè nhận hoa hồng',
        t41: 'Nạp tiền',
        t42: 'Đồng ý',
        t43: 'Hủy bỏ',
        t44: 'Bạn có chắc chắn muốn đăng xuất?',
        t45: 'Số tiền nạp',
        t46: 'Nạp tiền thành công',
        t47: 'Duyệt qua',
        t48: 'Chờ phê duyệt',
        t49: 'Tổng rút tiền',
        t50: 'Vui lòng đặt mật khẩu rút tiền trước',
        t51: 'Vui lòng nhập mật khẩu cũ',
        t52: 'Vui lòng nhập mật khẩu mới',
        t53: 'Vui lòng nhập xác nhận mật khẩu',
        t54: 'Mật khẩu hai lần không khớp',
        t55: 'Sao chép thành công',
        t56: 'Số tiền rút không được nhỏ hơn 30',
        t57: 'Đã gửi thành công, đang chuyển hướng',
        t58: 'Đánh giá không thành công',
        t59: 'Cài đặt ảnh đại diện',
        t60: 'Cài đặt ngay',
        t61: 'Cài đặt thành công',
        t62: 'Sau khi phê duyệt ví, bạn cần đăng nhập để rút tiền',
        t63: 'Rút tiền vào thẻ ngân hàng',
        t64: 'Rút tiền vào USDT (tỷ lệ 1:0.013)',
        t65: 'Số tài khoản ngân hàng',
        t66: 'Vui lòng nhập số tài khoản ngân hàng và mã IFSC cho thẻ ngân hàng bạn muốn gắn, cùng với họ tên đầy đủ và số điện thoại di động. Đảm bảo tất cả thông tin chính xác để dễ dàng thực hiện giao dịch thanh toán.',
        t67: 'Vui lòng liên kết thẻ ngân hàng trước',
        t68: 'Người dùng nạp tiền',
        t69: 'Người dùng nhận đơn',
        t70: 'Hoa hồng cấp dưới',
        t71: 'Người dùng rút tiền',
        t72: 'Chuyển vào Yebao',
        t73: 'Chuyển ra khỏi Yebao',
        t74: 'Lợi nhuận từ Yebao',
        t75: 'Hoa hồng nhận đơn',
        t76: "Số dư dưới 30, không thể tiếp tục giao dịch, vui lòng liên hệ với bộ phận hỗ trợ khách hàng",
        t77: 'Vui lòng nhập tên ngân hàng',
        t78: 'Vui lòng nhập số tài khoản ngân hàng',
        t80: 'Vui lòng nhập họ tên',
        t81: 'Vui lòng nhập số điện thoại',
        t82: 'Vui lòng nhập số tiền rút',
        t83: 'Sao chép',
        t84: 'Top 100 hàng ngày: Toàn cầu',
        t85: 'Nghe',
        t86: "Email",
        t87: "Vui lòng nhập email của bạn",
        "t88": "Mã ngân hàng",
        "t89": "Vui lòng nhập mã ngân hàng",
        t90: 'Chuyển khoản ngân hàng ',
        t91: '1. Rút tiền không mất phí',
        t92: '2. Khoản rút sẽ được ghi có thành công trong vòng 10–15 phút sau khi rút. Đối với các khoản rút ngoài giờ làm việc, tiền sẽ được ghi có vào giờ làm việc kế tiếp.'
    },
    movie: {
        t01: 'Phim và chương trình truyền hình thịnh hành',
        t02: 'Mật khẩu quỹ',
        t03: 'Chênh lệch đơn hàng',
        t04: 'Quản lý địa chỉ on-chain',
        t05: 'Vui lòng nhập',
        t06: 'Vui lòng nhập đúng địa chỉ on-chain và mạng tương ứng (ví dụ: ERC20/TRC20/BTC); nếu không, thanh toán/chuyển khoản có thể không đến nơi hoặc gây thất thoát tài sản.',
        t07: 'Rút về địa chỉ on-chain',
        t08: 'Vui lòng thêm',
        t09: 'Vui lòng thêm địa chỉ on-chain',
    },
    langType: '越南语'
}
